import React from 'react'
import CardLayout from '../../../components/layouts/CardLayout'
import ReactMarkdown from 'react-markdown';
import { useMainContext } from '../../../core/contexts/main';
import ClockIcon from '../../../components/icons/ClockIcon';
import { formatDateShort } from '../../plans/components/CurrentUserPlan/helper';
import { formatDate, Text } from '../../../modules/Dashboard';
import { BiCheckDouble } from 'react-icons/bi';
import { ClipLoader } from 'react-spinners';

const NotificationCard = ({ notif, onClick, mini = false }) => {
    const { main: { lang } } = useMainContext()
    const isUnread = !notif?.readAt

    return (
        <CardLayout
            className="!border-[#AD46FF33] relative cursor-pointer !p-5 hover:scale-[1.01]"
            onClick={() => onClick(notif)}
        >
            {
                isUnread ?
                    <div className='h-[98%] w-2 ltr:rounded-l-xl rtl:rounded-r-3xl bg-[#AA26FF] absolute ltr:left-[0] rtl:right-[0] top-1/2 -translate-y-1/2' /> :
                    <span className='absolute top-5 ltr:right-5 rtl:left-5'>
                        <Text tid={"read"} className='text-[#249A5F] text-xs sm:text-base' />
                    </span>
            }

            <div className="space-y-3 text-start">
                <div className='flex gap-3 items-center'>
                    {/* unread dot */}
                    {isUnread && (
                        <span className="w-3 h-3 rounded-full bg-[#AA26FF]" />
                    )}
                    <span className="font-medium">{notif.title}</span>
                </div>

                {/* body preview */}
                <div className="relative max-h-[54px] overflow-hidden text-sm">
                    <ReactMarkdown children={notif?.body} />

                    {/* blur fade */}
                    <div className="absolute bottom-0 left-0 right-0 h-8 backdrop-blur-[1px] bg-gradient-to-t from-[#0F0524] to-transparent pointer-events-none" />
                </div>
                {
                    !mini &&
                    <span className="flex items-center gap-1 text-[#C27AFF] text-sm">
                        <ClockIcon color="#C27AFF" size={18} />
                        {formatDateShort(notif?.createdAt, lang)}
                        <Text tid="at" />
                        {formatDate(notif?.createdAt, "time", lang)}
                    </span>
                }

            </div>
        </CardLayout>
    )
}


export default NotificationCard